module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "md-nav-tabs nav nav-tabs",
    attrs: {
      "role": "tablist"
    }
  }, [_vm._l((_vm.tabs), function(t) {
    return (!_vm.hasDefaultSlot) ? _c('nav-tab', {
      key: t.id,
      attrs: {
        "id": t.id,
        "name": t.name,
        "active": t.active,
        "icon": t.icon
      },
      on: {
        "onTabClick": _vm.onTabClick
      }
    }) : _vm._e()
  }), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bb6d13d","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/core/components/mdTab/nav-tabs.vue
// module id = 1498
// module chunks = 0